import { HttpClient, HttpHeaders } from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {API_PATH, RouterLinks} from '../constants';
import {FlowItem, Question, QuestionFlow} from '../models/underwriter.model';
import {QuestionFlowSessionStore} from '../questions/state/question-flow-session.store';
import {QuestionStore} from '../questions/state/question.store';
import {Observable} from 'rxjs';
import {QuestionFlowStore} from '../questions/state/question-flow.store';
import {SuperflowStore} from '../questions/state/superflow.store';
import {UserStore} from '../../authentication/state/user.store';
import {ShoppingCartStore} from '../questions/state/shopping-cart-store';
import {QuotesService} from '../../quotes/services/quotes.service';
import {MiniQuestionStore} from '../questions/state/mini-question.store';
import {MiniQuestionFlowSessionStore} from '../questions/state/mini-question-flow-session.store';
import { Alert } from '../utilities';

const headers = new HttpHeaders()
  .set('content-type', 'application/json')
  .set('Access-Control-Allow-Origin', '*')
  .set('Accept', 'application/json');

@Injectable({
  providedIn: 'root'
})
export class FlowPlayerService {

  constructor(
    private httpClient: HttpClient,
    private questionStore: QuestionStore,
    private router: Router,
    private questionFlowSessionStore: QuestionFlowSessionStore,
    private questionFlowStore: QuestionFlowStore,
    private superflowStore: SuperflowStore,
    private userStore: UserStore,
    private quotesService: QuotesService,
    private shoppingCartStore: ShoppingCartStore,
    private miniQuestionStore: MiniQuestionStore,
    private miniQuestionFlowSessionStore: MiniQuestionFlowSessionStore
  ) {
  }

  questionNumberRegex(question: Question): number {
    if (question.cent_aq_question_id !== 66) {
      return 0;
    }
    const regex = new RegExp('[0-9]+');
    const questionNumber = regex.exec(question.question_copy);
    if (questionNumber) {
      return +questionNumber[0];
    } else {
      return 0;
    }
  }

  pageQuestions(page: number, questions: Question[]): Question[] {
    return questions.filter((question: Question) => question.page === page && question.answer !== undefined && question.answer !== null && question.answer !== '');
  }


  flowQuestions(flowId: any, categoryId: any, sessionId: any, groupId: any, itemId: any, questionId: any = 0, person_id: number = 0, locationId: number = 0): Observable<any> {
    const currentUser: any = this.userStore.getValue();
    if (person_id === 0 || !person_id) {
      try {
        person_id = currentUser?.person_id;
      } catch (e) {
      }
    }
    const requestBody = {
      FlowId: flowId,
      CategoryId: categoryId,
      GroupId: groupId,
      SessionId: sessionId,
      ItemId: itemId,
      PersonId: person_id,
      QuestionId: questionId,
      LocationId: locationId,
    };
    return this.httpClient.post(`${API_PATH.GET_FLOW_QUESTIONS}`, requestBody, {headers});
  }

  getNextFlow(session_id: string, superflow_id: number, flow_id: number): Observable<any> {
    return this.httpClient.get(`${API_PATH.GET_NEXTFLOW}/${session_id}/${superflow_id}/${flow_id}`,
      {headers, responseType: 'json'});
  }

  getNextSuperFlow(session_id: string, superflow_id: number): Observable<any> {
    return this.httpClient.get(`${API_PATH.GET_NEXT_SUPERFLOW}/${session_id}/${superflow_id}`,
      {headers, responseType: 'json'});
  }

  getFlows(superflow_id: number): Observable<any> {
    return this.httpClient.get(`${API_PATH.GET_FLOWS}/${superflow_id}`, {headers, responseType: 'json'});
  }

  startSuperFlow(superflow_id: number, categoryId: any, flow_id: any, group_id: any, item_id: any, session_id: any = null, css: any = '', reset: boolean = true, person_id: number = 0): void {
    if (reset) {
      this.questionStore.reset();
      this.questionFlowSessionStore.reset();
    }

    const date = new Date();
    if (!session_id) {
      session_id = date.getTime().toString();
    }
    // const session_id = date.getTime().toString();
    this.getNextFlow(session_id, superflow_id, flow_id)
      .subscribe((flow: any[]) => {
        if (!flow?.length) {
          return;
        }
        const currentUser: any = this.userStore.getValue();
        //let person_id = 0;
        if (person_id === 0){
          person_id = currentUser?.person_id;
        }
        // this.quotesService.createQuote(session_id,categoryId,group_id,person_id,'0').subscribe(result => {});
        this.flowQuestions(flow[0]?.next, categoryId, session_id, group_id, item_id, 0, person_id)
          .subscribe((flowQuestions: Question[]) => {
            this.questionStore.set(flowQuestions);
            const firstQuestion = flowQuestions?.find((q: Question) => q.flow_index === 1);
            if (firstQuestion?.cent_aq_question_id) {
              this.questionStore.setActive(firstQuestion?.cent_aq_question_id);
              this.questionFlowSessionStore.update({
                session_id,
                state: 'Pending',
                category_id: categoryId,
                flow_id: flow[0]?.next,
                item_id,
                group_id,
                superflow_id,
                css,
                class_id: firstQuestion?.product_class_id,
                flow_type_id: flow[0]?.flow_type_id
              });
              this.getFlows(superflow_id)
                .subscribe((flows: QuestionFlow[]) => {
                  this.questionFlowStore.set(flows);
                  this.questionFlowStore.setActive(flow[0].next);
                });
              const flowItems: FlowItem[] = [];
              flowItems.push({
                flow_id: flow[0].next,
                questions: flowQuestions
              });
              this.superflowStore.update({
                session_id,
                superflow_id,
                flow_items: flowItems
              });
              if (reset) {
                this.shoppingCartStore.reset();
              }
              this.router.navigate([`/${RouterLinks.QuestionFlow}`], {state: {css}});
            }
          });
      });
  }

  startMiniFlow(parent_flow_id: number, flow_id: number, class_id: number, category_id: number, group_id: number, item_id: string, session_id: string): any {
    this.miniQuestionStore.reset();
    
    return this.flowQuestions(flow_id, category_id, session_id, group_id, item_id)
      .subscribe((flowQuestions: Question[]) => {
        this.miniQuestionStore.set(flowQuestions);
        const firstQuestion = flowQuestions.find((q: Question) => q.flow_index === 1);
        this.miniQuestionFlowSessionStore.update({
          session_id,
          state: 'Pending',
          category_id,
          item_id,
          group_id,
          class_id,
          flow_id,
          parent_flow_id
        });
        if (firstQuestion?.cent_aq_question_id){
          this.miniQuestionStore.setActive(firstQuestion?.cent_aq_question_id);
        }
      });
  }

  startFlow(superflow_id: any, flowId: any, categoryId: any, group_id: any, item_id: any, session_id: any, css: string, question_id: any): any {
    this.questionStore.reset();
    this.shoppingCartStore.reset();
    if (!session_id) {
      const date = new Date();
      session_id = date.getTime().toString();
    }
    const currentUser: any = this.userStore.getValue();
    let person_id = 0;
    if (!currentUser?.broker_id) {
      person_id = currentUser?.person_id;
    }

    return this.flowQuestions(flowId, categoryId, session_id, group_id, item_id, question_id)
      .subscribe((flowQuestions: Question[]) => {
        this.questionStore.set(flowQuestions);
        const firstQuestion = flowQuestions.find((q: Question) => q.flow_index === 1);
        if (firstQuestion?.cent_aq_question_id !== undefined) {
          this.questionStore.setActive(firstQuestion?.cent_aq_question_id);
          this.questionFlowSessionStore.update({
            session_id,
            state: 'Pending',
            category_id: categoryId,
            flow_id: flowId,
            group_id,
            superflow_id,
            css,
            class_id: firstQuestion?.product_class_id,
            flow_type_id: firstQuestion?.flow_type_id
          });
          
          this.router.navigate([`/${RouterLinks.QuestionFlow}`]);
        }
      });
  }


}
